module.exports = __webpack_public_path__ + "static/showreel_2025_clip-e9d7ec1934bc6f01625d45c35b71402b.mp4";